// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pd-0";
export var animationContainer = "_pd-1";
export var itemPrice = "_pd-a";
export var itemizedContent = "_pd-9";
export var itemizedHeader = "_pd-7";
export var itemizedRow = "_pd-8";
export var itemizedSection = "_pd-6";
export var modalContent = "_pd-2";
export var orderName = "_pd-3";
export var refundOption = "_pd-4";
export var refundOptionsContainer = "_pd-5";
export var shippingLabel = "_pd-b";
export var totalRow = "_pd-c";